import { CONSTANT } from "./constants";

export const useAsyncGet = async (url: string, params: any) => {
  let endpointURL = `${url}`;
  if(params !== null) {
    endpointURL = `${endpointURL}?`;
    Object.entries(params).forEach(entry => {
      const [key, value] = entry;
      endpointURL = `${endpointURL}${key}=${value}&`;
    });
  }
  return await fetch(endpointURL, {
    credentials: "include"
  }).then((resp: Response) => {
    return resp.json();
  }).catch((error: Error) => {
    return error;
  });
};

export const useAsyncPOST = async (url: string, body: any) => {
  return await fetch(url, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(body)
  }).then((resp: Response) => {
    return resp.json();
  }).catch((error: Error) => {
    return error;
  });
};

export const useAsyncPOSTText = async (url: string, body: any): Promise<string | Error> => {
  return await fetch(url, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(body)
  }).then((resp: Response) => {
    return resp.text();
  }).catch((error: Error) => {
    return error;
  });
};

export const useAsyncGetAddress = async (lat: number, lon: number): Promise<string | Error> => {
  const endpointURL = `${CONSTANT.URL.OSM_QUERY_ADDRESS}&lat=${lat}&lon=${lon}`;
  const result = await fetch(endpointURL, {
  }).then((resp: Response) => {
    return resp.json();
  }).catch((error: Error) => {
    return error;
  });
  if( result instanceof Error) {
    return result;
  }
  const { address } = result;
  const addressAttr = []; 
  address?.house_number ? addressAttr.push(address.house_number) : null;
  address?.road ? addressAttr.push(address.road) : null;
  address?.suburb ? addressAttr.push(address.suburb) : null;
  address?.country ? addressAttr.push(address.country) : null;
  address?.postcode ? addressAttr.push(address.postcode) : null;
  return addressAttr.join(", ");
};

export const usePollGet = async (url: string, params: any, stopCondition: (response: any) => boolean, duration: number = 3000, timeout: number = 15000) => {
  const stopTime = Date.now() + timeout;

  const wait = async (duration: number)  => {
    return new Promise(resolve => {
      setTimeout(resolve, duration);
    });
  };
  
  const poll = async () => {
    let result = await useAsyncGet(url, params);
    while (!stopCondition(result) && Date.now() < stopTime) {
      await wait(duration);
      result = await useAsyncGet(url, params);
    }
    return result;
  };
  
  const response = await poll();
  return response;
};
